module.exports = __webpack_public_path__ + "img/fashion_81.b4fb895a.jpg";